<template>
  <div class="browse-row" :style="rowStyles">
    <div class="row-container">
      <Chevron v-if="row.children.length"
        :rtl-override="true"
        :expanded="expanded"
        @expand="onExpand"
      />
      <a class="row-link" href @click.prevent="onSelection">{{ row.textContent }}</a>
    </div>
    <div v-if="expanded && row.children.length">
      <div v-if="row.children.length">
        <collation-row
          v-for="(child, index) in row.children"
          :key="`child-${index}`"
          :row="child"
          :work="work"
          @selected="selection => $emit('selected', selection)"
        >
        </collation-row>
      </div>
      <div v-else class="empty-message">
        <small>{{ $t('noSectionsWarning') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
  import Chevron from '../Chevron.vue';
  import { COLLAPSE_ALL_BROWSE_CONTENT } from '../../constants';

  export default {
    components: {
      Chevron,
    },
    name: 'collation-row',
    props: ['row', 'work', 'rtl'],
    created() {
    },
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      collapse() {
        return this.$store.state.collapseAll;
      },
      rowStyles() {
        const styleDeclarations = [];
        const chevronWidth = 24;
        if (this.row.children.length > 0) {
          styleDeclarations.push(`margin-right: -${chevronWidth}px;`);
        }
        const depthModifier = 8;
        const paddingValue = chevronWidth + (this.row.depth * depthModifier);
        styleDeclarations.push(`padding-right: ${paddingValue}px;`);
        return `${styleDeclarations.join(' ')};`;
      },
    },
    watch: {
      collapse(newVal) {
        if (newVal === true) {
          this.expanded = false;
        }
      },
    },
    methods: {
      onSelection() {
        this.$emit('selected', {
          work: this.work.urn,
          idx: this.row.idx,
        });
      },
      onExpand() {
        this.expanded = !this.expanded;
        this.$store.dispatch(COLLAPSE_ALL_BROWSE_CONTENT, { status: false });
      },
    },
  };
</script>

<style lang="scss">
  @import './Browse';
  .empty-message {
    padding-left: 30px;
    [dir="rtl"] & {
      padding-left: 30px;
    }
  }
  .row-container {
    display: flex;
  }
  .row-link {
    margin-inline-start: 10px;
  }
</style>
